import React, { useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "../styles/style.css";

const SiteLayout = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const path =
    useLocation().pathname.replace(/\/$/, "") || "/";

  const navClass = (to, { home } = {}) =>
    ({ isActive }) => {
      const active = home
        ? path === "/" || path === "/homepage" || isActive
        : isActive;
      return active ? "active" : undefined;
    };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="site-layout">
      <header className="header">
        <h1 className="header-brand">
          <NavLink to="/homepage" className="logo" onClick={closeMenu}>
            <span className="logo-mark" aria-hidden="true">
              <svg
                className="logo-ring"
                viewBox="0 0 120 120"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="60"
                  cy="60"
                  r="54"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1"
                />
              </svg>
            </span>
            <span className="logo-text">Impact Afghanistan</span>
          </NavLink>
        </h1>
        <nav className="nav-items">
          <NavLink to="/about" end className={navClass("/about")} onClick={closeMenu}>
            About
          </NavLink>
          <NavLink
            to="/database"
            end
            className={navClass("/database")}
            onClick={closeMenu}
          >
            Database
          </NavLink>
          <NavLink to="/form" end className={navClass("/form")} onClick={closeMenu}>
            Submit Research
          </NavLink>
          <NavLink
            to="/engagement"
            end
            className={navClass("/engagement")}
            onClick={closeMenu}
          >
            Engagement
          </NavLink>
          <NavLink
            to="/homepage"
            end
            className={navClass("/homepage", { home: true })}
            onClick={closeMenu}
          >
            Home
          </NavLink>
        </nav>
        <button
          className="hamburger"
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="sr-only">Menu</span>
          <div className="hamburger-lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </header>

      <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
        <nav className="mobile-menu-content">
          <NavLink to="/about" end className={navClass("/about")} onClick={closeMenu}>
            About
          </NavLink>
          <NavLink
            to="/homepage"
            end
            className={navClass("/homepage", { home: true })}
            onClick={closeMenu}
          >
            Home
          </NavLink>
          <NavLink
            to="/database"
            end
            className={navClass("/database")}
            onClick={closeMenu}
          >
            Database
          </NavLink>
          <NavLink to="/form" end className={navClass("/form")} onClick={closeMenu}>
            Submit Research
          </NavLink>
          <NavLink
            to="/engagement"
            end
            className={navClass("/engagement")}
            onClick={closeMenu}
          >
            Engagement
          </NavLink>
        </nav>
      </div>

      <div className="site-layout__body">
        <Outlet />
      </div>
    </div>
  );
};

export default SiteLayout;
